import { busbar_registry } from "./busbar_registry";

export const generate_busbar_sensors_demo = ({ location_id }) => {
    const location = busbar_registry.find(
        l => l.location_id === Number(location_id)
    );

    if (!location) return [];

    return location.sensors.map(sensor => ({
        id: sensor.meter_id,
        name: sensor.sensor_name,
    }));
};